import React from 'react';

interface WrenchDuoProps {
    size?: number;
    className?: string;
    'aria-hidden'?: boolean | 'true' | 'false';
}

const WrenchDuo: React.FC<WrenchDuoProps> = ({
    size = 64,
    className,
    'aria-hidden': ariaHidden,
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={ariaHidden}
        role={ariaHidden ? undefined : 'img'}
    >
        <g clipPath="url(#wrench_duo_clip)">
            <path
                d="M32 1C49.1211 1 63 14.879 63 32C63 49.1211 49.1211 63 32 63C14.879 63 1 49.1197 1 32C1 14.8803 14.879 1 32 1Z"
                stroke="#26255E"
                strokeWidth="2"
            />
            <path
                d="M47.4189 26.1406L37.0231 36.7376L32.1474 38.3949L29.1509 35.3403L25.6459 31.7675L27.2717 26.7974L37.6675 16.2004C35.8985 15.5425 34.0305 15.2039 32.1474 15.2C27.8369 15.2 23.7029 16.9455 20.6549 20.0525C17.6069 23.1595 15.8945 27.3735 15.8945 31.7675C15.8945 33.7456 16.2521 35.6346 16.876 37.3944L-1.58016 56.2059C-2.24247 56.8798 -2.76295 57.6843 -3.10974 58.5703C-3.45654 59.4563 -3.62238 60.4051 -3.5971 61.3586C-3.57182 62.3122 -3.35596 63.2505 -2.96273 64.1161C-2.5695 64.9816 -2.00717 65.7564 -1.31012 66.3928C0.000825167 67.5976 1.71531 68.2436 3.47978 68.1977C5.24425 68.1517 6.92416 67.4174 8.17309 66.146L26.6292 47.3345C28.3977 47.9923 30.265 48.3308 32.1474 48.335C36.458 48.335 40.592 46.5895 43.64 43.4825C46.688 40.3755 48.4004 36.1615 48.4004 31.7675C48.3965 29.848 48.0644 27.9438 47.4189 26.1406ZM2.88953 64.9026C2.1547 64.8993 1.44304 64.6401 0.872584 64.1679C0.341323 63.7434 -0.0463548 63.1601 -0.236135 62.4997C-0.425916 61.8394 -0.408292 61.1351 -0.185733 60.4854C0.0368254 59.8358 0.453168 59.2734 1.00497 58.8771C1.55677 58.4807 2.21638 58.2703 2.8914 58.2752C3.91943 58.2752 4.82454 58.7725 5.4205 59.5319C5.86561 60.0976 6.14124 60.8077 6.14124 61.5898C6.14124 63.4199 4.68673 64.9026 2.8914 64.9026"
                fill="#26255E"
            />
        </g>
        <defs>
            <clipPath id="wrench_duo_clip">
                <rect width="64" height="64" rx="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default WrenchDuo;
